import React from 'react';
import classNames from 'classnames';
import cls from './EmptyGant.module.css';

export const EmptyGant = ({ isAllNullPosition }) => {
    return (
        <div className={classNames(cls.EmptyGant)}>
            {isAllNullPosition ? (
                <>
                    <p>{i18next.t('EmptyGant.return.isAllNullPosition')}</p>
                </>
            ) : (
                <>
                    <p className={cls.bold}>{i18next.t('EmptyGant.return.text.part1')}</p>
                    <p>{i18next.t('EmptyGant.return.text.part2')}</p>
                </>
            )}
        </div>
    );
};
